import jsonData from "@/assets/contents/drill_k-jimon23sei2.json";

function getJson() {
  const qAry = jsonData.qAry;
  var allQuestions = [];
  for (var i = 0; i < qAry.length; i++) {
    var questions = qAry[i].questions;
    for (var j = 0; j < questions.length; j++) {
      var q = questions[j];
      let imgId;
      if(q.imgId){
        imgId = q.imgId
      }
      allQuestions.push({
        head_id : qAry[i].head_id,
        questionHeader: qAry[i].header,
        gid: q.gid,
        origId : q.id,
        id: 0,
        imgId : imgId,
        text: q.text,
        textEng: q.textEng,
        answers: q.answers,
        correct: null,
        answer: q.answer,
        explanation: q.explanation
      });
    }
  }

  var lastGid = allQuestions[allQuestions.length - 1].gid;
  allQuestions = allQuestions.map(function(it, key) {
    lastGid++;
    it.id = key;
    it.gid = lastGid;
    return it;
  });

  jsonData.qAry[qAry.length] = {
    head_id: qAry.length,
    header: "すべてのジャンルから解く",
    questions: allQuestions
  };

  return jsonData;
}

export default { getJson };
